import { Box, Card, CardContent, Container } from "@mui/material";
import { Link, Redirect, Route, Switch } from "react-router-dom";
import Logo from "../../../_metronic/_assets/media/logos/login-logo.png";
import LogoLight from "../../../_metronic/_assets/media/logos/logo-light.png";
import Login from "./Login";
import Password from "./Password";
import PassActions from "./Password/enum/Actions";
import { useThemeApp } from "_metronic/materialUIThemeProvider/ThemeProvider";
import "./AuthPage.css";

export default function AuthPage() {
  const { isDarkMode } = useThemeApp();
  const themeClass = isDarkMode ? "dark-mode" : "light-mode";

  return (
    <div className={`auth-page-container ${themeClass}`}>
      {/* Círculos decorativos */}
      <div className={`bg-circle-1 ${themeClass}`}></div>
      <div className={`bg-circle-2 ${themeClass}`}></div>

      <Container maxWidth="sm" className="card-container">
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          minHeight="100vh"
        >
          <Card elevation={0} className={`auth-card ${themeClass}`}>
            <CardContent className="auth-card-content">
              <div className="logo-container">
                <Link to="/" style={{ textDecoration: "none" }}>
                  <img
                    alt="Logo"
                    src={isDarkMode ? LogoLight : Logo}
                    className="auth-logo"
                  />
                </Link>
              </div>

              <Switch>
                <Route
                  path="/auth/ativar-conta"
                  component={() => <Password action={PassActions.CriarConta} />}
                />
                <Route
                  path="/auth/recuperar-senha"
                  component={() => (
                    <Password action={PassActions.RecuperarSenha} />
                  )}
                />
                <Route
                  path="/auth/cadastrar-senha"
                  component={() => (
                    <Password action={PassActions.CadastrarSenha} />
                  )}
                />
                <Route path="/auth/login" component={Login} />
                <Redirect from="/auth" exact={true} to="/auth/login" />
                <Redirect to="/auth/login" />
              </Switch>
            </CardContent>
          </Card>
        </Box>
      </Container>
    </div>
  );
}
